import React from 'react';
import { connect } from 'react-redux';
import { createSiteNote, removeSiteNote } from '../../../store/api/calls';
import { setSessionVar } from '../../../store/actions';
import NoteModal from './NoteModal';

class SiteNoteModal extends React.Component {
  static defaultProps = {
    categories: [],
    notes: [],
    onCloseModal: () => null,
  };

  constructor(props) {
    super(props);
    this.state = {
      refreshCounter: 0,
    };
  }

  componentWillUnmount() {
    this.props.hideModalAndUnsetSite();
  }

  onClose = () => {
    this.props.hideModalAndUnsetSite();
  };

  getNotes = () => {
    return this.props.site.notes || [];
  };

  getCategories = () => {
    return this.props.categories.filter((d) => d.for_sites);
  };

  getTitle = () => {
    return `Edit Notes for ${this.props.site.name}`;
  };

  onCreateNote = (category_id, note) => {
    let creationObject = {
      category: category_id,
      note: note,
      site_id: this.props.site.id,
    };

    return createSiteNote(creationObject).catch((err) => {
      console.log('createSiteNote', err);
    });
  };

  onRemoveNote = (sitenote_id) => {
    return removeSiteNote(sitenote_id);
  };

  render() {
    return (
      <>
        {this.props?.site?.id && (
          <NoteModal
            {...this.props}
            title={this.getTitle()}
            isOpen={this.props.site.id}
            onCloseModal={this.onClose}
            onCreateNote={this.onCreateNote}
            onRemoveNote={this.onRemoveNote}
            notes={this.getNotes()}
            refreshCounter={this.state.refreshCounter}
            loading={this.props.loading}
            categories={this.getCategories()}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  categories: state.siteNotes.categories,
  site: state.sites.data.find((d) => d.id === state.session.vars.siteNoteModalSite?.id) || {},
  loading: state.siteNotes.loading,
});

const mapDispatchToProps = (dispatch) => ({
  hideModalAndUnsetSite: () => dispatch(setSessionVar('siteNoteModalSite', {})), //if set, modal visible. siteObj is null hides modal
});

export default connect(mapStateToProps, mapDispatchToProps)(SiteNoteModal);
